var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#00075e",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 422.894 422.894",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00075e",
    id: "XMLID_22_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00075e",
    id: "XMLID_481_",
    d: "M420.679,160.174c-7.681-23.637-33.066-36.572-56.704-28.893c-18.632,6.054-30.606,23.112-31.081,41.643 l-32.068,10.42c4.452,8.842,7.627,18.432,9.288,28.525l32.051-10.414c11.276,14.711,30.99,21.476,49.623,15.421 C415.422,209.195,428.359,183.809,420.679,160.174z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00075e",
    id: "XMLID_482_",
    d: "M226.447,129.281V95.586c17.476-6.18,30-22.838,30-42.43c0-24.852-20.148-45-45-45 c-24.853,0-45,20.147-45,45c0,19.592,12.524,36.25,30,42.43v33.695c4.894-0.739,9.903-1.125,15-1.125 C216.544,128.156,221.553,128.542,226.447,129.281z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00075e",
    id: "XMLID_483_",
    d: "M90,172.924c-0.477-18.529-12.449-35.589-31.082-41.643c-23.636-7.68-49.023,5.256-56.703,28.892 c-7.68,23.637,5.256,49.023,28.892,56.703c18.634,6.054,38.348-0.709,49.624-15.421l32.05,10.414 c1.661-10.094,4.836-19.683,9.288-28.525L90,172.924z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00075e",
    id: "XMLID_484_",
    d: "M121.388,326.591c-17.77-5.272-37.694,0.843-49.209,16.692c-14.607,20.106-10.15,48.248,9.955,62.856 c20.107,14.607,48.248,10.15,62.856-9.956c11.516-15.85,11.175-36.689,0.668-51.96l19.819-27.278 c-8.959-4.657-17.127-10.631-24.249-17.662L121.388,326.591z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00075e",
    id: "XMLID_486_",
    d: "M277.235,344.226c-10.506,15.271-10.847,36.108,0.669,51.959c14.608,20.106,42.75,24.564,62.855,9.956 c20.106-14.609,24.564-42.75,9.955-62.857c-11.516-15.85-31.44-21.966-49.21-16.691l-19.841-27.309 c-7.122,7.032-15.29,13.005-24.249,17.662L277.235,344.226z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_487_",
    cx: 211.447,
    cy: 228.156,
    r: 70
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.e3ead4063f583f2fe935c056c6a3e232.svg";
export { ForwardRef as ReactComponent };